import React, { useState, useEffect, useRef } from 'react';
import {
  Briefcase, Clock, FileCheck, FileText, Calendar,
  Check, AlertCircle, Star, ChevronDown, RefreshCw, Eye, Activity, ArrowLeft,
  CheckCircle, X, Loader, ArrowRight, List, ChevronLeft, ChevronRight, ArrowUpDown, ArrowUp, ArrowDown
} from 'lucide-react';
import apiService from '../config';
import { useLanguage } from '../StoreContext/LanguageContext';
import { useProjectCategory } from "../Context/ProjectCategoryContext";
// import DashboardHighway from "./DashboardHighway";
// import DashboardRailway from "./DashboardRailway";
// import GovDashboard from './AdminDashboard';

const DashboardHighway = ({ setSelectedComponent }) => {
  const { language, translations } = useLanguage();

  const [userData, setUserData] = useState([]);
  const [showWelcome, setShowWelcome] = useState(false);
  const [showProjectSelection, setShowProjectSelection] = useState(false);
  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [projectsLoading, setProjectsLoading] = useState(false);
  const [projectError, setProjectError] = useState('');

  const [filterCategory, setFilterCategory] = useState('');
  const [filterDivision, setFilterDivision] = useState('');
  const [filterLegacy, setFilterLegacy] = useState('0');
  const [filtersApplied, setFiltersApplied] = useState(false);

  const [proposalList, setProposalList] = useState([]);
  const [selectedProposal, setSelectedProposal] = useState('');
  const [selectedProposalId, setSelectedProposalId] = useState(null);
  const [proposalsLoading, setProposalsLoading] = useState(false);
  const [proposalError, setProposalError] = useState('');

  const [updatingProject, setUpdatingProject] = useState(false);
  const { projectCategory } = useProjectCategory();

  const [selectedProposalForTracking, setSelectedProposalForTracking] = useState(null);
  const [trackingStatus, setTrackingStatus] = useState(null);
  const [trackingHistory, setTrackingHistory] = useState([]);
  const [trackingLoading, setTrackingLoading] = useState(false);

  const TRACKING_LIMIT = 10;
  const [trackingPage, setTrackingPage] = useState(1);
  const [trackingTotalPages, setTrackingTotalPages] = useState(1);
  const [trackingTotalRecords, setTrackingTotalRecords] = useState(0);
  const [trackingPaginationLoading, setTrackingPaginationLoading] = useState(false);

  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const [sectionCounts, setSectionCounts] = useState({
    section11: 0, section12: 0, section15: 0,
    section19: 0, section21: 0, section23: 0, payment: 0
  });

  const [selectedSection, setSelectedSection] = useState(null);
  const [sectionProposals, setSectionProposals] = useState([]);
  const [sectionProposalsLoading, setSectionProposalsLoading] = useState(false);
  const [sectionProposalsError, setSectionProposalsError] = useState('');

  const [dashboardProposalList, setDashboardProposalList] = useState([]);
  const [dashboardProposalsLoading, setDashboardProposalsLoading] = useState(false);
  const [dashboardProposalError, setDashboardProposalError] = useState('');

  const [searchQuery, setSearchQuery] = useState('');

  // Sort: { key: string | null, dir: 'asc' | 'desc' | null }
  const [sortConfig, setSortConfig] = useState({ key: null, dir: null });

  const [mainView, setMainView] = useState('proposals');
  const [viewKey, setViewKey] = useState(0);
  const [mounted, setMounted] = useState(false);

  const [categories, setCategories] = useState([]);

  const canProceed = selectedProject !== null;

  // user role
  const ROLES = {
    COLLECTOR: 1,
    LAO: 3,
    TEHSILDAR: 5,
    SAMANVAY: 6,
    SURVEYOR: 7,
    DATA_ENTRY: 14,
    DSLR: 15,
    PROJECT_INCHARGE: 18,
    AGRICULTURE: 21,
    DRO: 22,
    OTHER: 23,
    FOREST: 24
  };

  const hideDashboard =
    userData.user_role === ROLES.SURVEYOR ||
    userData.user_role === ROLES.TEHSILDAR || userData.user_role === userData.DRO;;

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 60);
    return () => clearTimeout(t);
  }, []);

  // ========== INITIAL LOAD ==========
  useEffect(() => {
    const initializeDashboard = async () => {
      try {
        const welcomeShown = localStorage.getItem('welcomeScreenShown');
        if (welcomeShown) {
          const storedUserData = localStorage.getItem('userData');
          if (storedUserData) setUserData(JSON.parse(storedUserData));

          const storedCategory = localStorage.getItem('project_category')?.replace(/^"|"$/g, '');
          if (storedCategory === 'Railway' || storedCategory === 'General') {
            window.dispatchEvent(new Event("projectCategoryChanged"));
          }

          setShowWelcome(false);
          setShowProjectSelection(false);
          setIsLoading(false);
          return;
        }
        setShowWelcome(true);
        setIsLoading(false);
        await new Promise(resolve => setTimeout(resolve, 200));
        const result = await apiService.getProfile();
        if (result?.data) {
          const user = result.data;
          setUserData(user);
          const currentProjectId = user.default_project;
          const currentProposalId = user.default_proposal;
          localStorage.setItem('userData', JSON.stringify(user));
          if (!currentProjectId) {
            await new Promise(resolve => setTimeout(resolve, 2300));
            setShowWelcome(false);
            localStorage.setItem('welcomeScreenShown', 'true');
            setTimeout(() => { setShowProjectSelection(true); fetchCategories(); }, 300);
            return;
          }
          localStorage.setItem('currentProjectId', currentProjectId);
          localStorage.setItem('currentProposalId', currentProposalId);
          if (currentProjectId) {
            const projectDetailsResult = await apiService.getAllProjectsafterhomepage(currentProjectId);
            if (projectDetailsResult?.data) {
              const projectData = Array.isArray(projectDetailsResult.data)
                ? projectDetailsResult.data[0] : projectDetailsResult.data;
              localStorage.setItem('currentProjectData', JSON.stringify(projectData));
              localStorage.setItem('selectedProject', JSON.stringify(projectData));
              localStorage.setItem('project_category', projectData.project_category);
              if (projectData.project_category === 'Railway' || projectData.project_category === 'Highway') {
                window.dispatchEvent(new Event("projectCategoryChanged"));
              }
            }
          }
          if (currentProjectId && currentProposalId) {
            const storedCategory = localStorage.getItem('project_category');
            let response;
            if (storedCategory === "Railway") response = await apiService.getRailwayProposalById(currentProjectId, currentProposalId);
            else if (storedCategory === "Highway") response = await apiService.getHighwayProposalById(currentProjectId, currentProposalId);
            else response = await apiService.getProposalById(currentProjectId, currentProposalId);
            if (response?.status === 200 && response.data) {
              localStorage.setItem('currentProposalData', JSON.stringify(response.data));
              localStorage.setItem('selectedProposal', JSON.stringify(response.data));
            }
          }
          setTimeout(() => {
            setShowWelcome(false);
            localStorage.setItem('welcomeScreenShown', 'true');
          }, 2300);
        }
      } catch (error) {
        console.error('Error fetching user profile:', error);
        setShowWelcome(false);
        setShowProjectSelection(true);
        setIsLoading(false);
      }
    };
    initializeDashboard();
  }, []);

  useEffect(() => {
    if (!showWelcome && !showProjectSelection) {
      fetchSectionCounts();
      fetchDashboardProposals();
    }
  }, [showWelcome, showProjectSelection]);

  // ========== SORT HANDLER ==========
  // Cycles: none → asc → desc → none
  const handleSort = (key) => {
    setSortConfig(prev => {
      if (prev.key === key) {
        if (prev.dir === 'asc') return { key, dir: 'desc' };
        if (prev.dir === 'desc') return { key: null, dir: null };
      }
      return { key, dir: 'asc' };
    });
  };

  // ========== FILTER + SORT HELPER ==========
  const applySortAndFilter = (list) => {
    const q = searchQuery.toLowerCase();
    let result = list.filter(p =>
      (p.acquisition_proposal_no || '').toLowerCase().includes(q) ||
      (p.section_11_bhusampadan_no || '').toLowerCase().includes(q)
    );
    if (sortConfig.key && sortConfig.dir) {
      result = [...result].sort((a, b) => {
        const aVal = (a[sortConfig.key] || '').toLowerCase();
        const bVal = (b[sortConfig.key] || '').toLowerCase();
        if (aVal < bVal) return sortConfig.dir === 'asc' ? -1 : 1;
        if (aVal > bVal) return sortConfig.dir === 'asc' ? 1 : -1;
        return 0;
      });
    }
    return result;
  };

  const filteredDashboardProposals = applySortAndFilter(dashboardProposalList);
  const filteredSectionProposals = applySortAndFilter(sectionProposals);

  // ========== SORT ICON COMPONENT ==========
  const SortIcon = ({ colKey }) => {
    if (sortConfig.key !== colKey) return <ArrowUpDown className="h-3 w-3 ml-1 opacity-40 inline-block flex-shrink-0" />;
    if (sortConfig.dir === 'asc') return <ArrowUp className="h-3 w-3 ml-1 inline-block flex-shrink-0 text-amber-300" />;
    return <ArrowDown className="h-3 w-3 ml-1 inline-block flex-shrink-0 text-amber-300" />;
  };

  const fetchSectionCounts = async () => {
    try {
      const response = await apiService.getTrackingProjectSectionCounts();
      if (response?.data) {
        const data = response.data.sectionCounts ?? response.data;
        setSectionCounts(prev => ({ ...prev, ...data }));
      }
    } catch (error) { }
  };

  const fetchSectionProposals = async (section) => {
    setSectionProposalsLoading(true);
    setSectionProposals([]);
    setSectionProposalsError('');
    try {
      const response = await apiService.getTrackingProjectSectionProposals(section);
      if (response?.data) {
        const data = Array.isArray(response.data.proposals) ? response.data.proposals
          : Array.isArray(response.data) ? response.data : [];
        setSectionProposals(data);
        if (data.length === 0) setSectionProposalsError('No proposals found for this section');
      }
    } catch (error) {
      setSectionProposalsError('Failed to load proposals');
    } finally {
      setSectionProposalsLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const result = await apiService.getAllCategory();
      if (result?.data) setCategories(result.data);
    } catch (e) { }
  };

  const fetchDashboardProposals = async () => {
    setDashboardProposalsLoading(true);
    setDashboardProposalError('');
    setDashboardProposalList([]);
    try {
      const response = await apiService.getAllDashboardProposal();
      if (response?.status === 200 && response.data) {
        const data = Array.isArray(response.data) ? response.data : [];
        setDashboardProposalList(data);
        if (data.length === 0) setDashboardProposalError('No proposals available');
      }
    } catch (error) {
      setDashboardProposalError('Failed to load proposals');
    } finally {
      setDashboardProposalsLoading(false);
    }
  };

  const fetchModalProjects = async (category = '', division = '', legacy = '0') => {
    setProjectsLoading(true); setProjectError(''); setSelectedProject(null);
    setDropdownOpen(false); setSelectedProposal(''); setSelectedProposalId(null); setProposalList([]);
    try {
      const storedCategory = localStorage.getItem('project_category');
      const cleanedCategory = storedCategory ? storedCategory.replace(/^"|"$/g, '') : '';
      const categoryToUse = category;
      const result = await apiService.getAllProjectsafterhomepage(null, { category: categoryToUse, division, legacy });
      if (result?.status === 200 && result.data) {
        const projectsData = result.data.data || result.data;
        setProjects(Array.isArray(projectsData) ? projectsData : []);
        if (!Array.isArray(projectsData) || projectsData.length === 0) setProjectError('No projects found');
      }
    } catch (error) { setProjectError('Failed to load projects'); setProjects([]); }
    finally { setProjectsLoading(false); }
  };

  const fetchModalProposals = async (projectId, category) => {
    setProposalsLoading(true); setProposalError(''); setProposalList([]);
    try {
      const cat = category || filterCategory || localStorage.getItem('project_category') || '';
      let response;
      if (cat === 'Railway') {
        response = await apiService.getRailwayProposal(projectId);
      } else if (cat === 'Highway') {
        response = await apiService.getHighwayProposal(projectId);
      } else {
        response = await apiService.getAllUserProposal(projectId);
      }
      if (response?.status === 200 && response.data) {
        const data = Array.isArray(response.data) ? response.data : [];
        setProposalList(data);
        if (data.length === 0) setProposalError('No proposals available for this project');
      }
    } catch (error) { setProposalError('Failed to load proposals'); }
    finally { setProposalsLoading(false); }
  };

  const handleProjectSelectOnly = (project) => {
    setSelectedProject(project); setDropdownOpen(false);
    setSelectedProposal(''); setSelectedProposalId(null); setProposalList([]);
    const projectId = project.id || project.project_id;
    if (projectId) fetchModalProposals(projectId, filterCategory);
  };

  const handleProceedToDashboard = async () => {
    if (!selectedProject) { alert('Please select a project before proceeding.'); return; }
    setUpdatingProject(true);
    try {
      const projectId = selectedProject.id || selectedProject.project_id;
      const profileUpdateData = { default_project: projectId };
      if (selectedProposalId) profileUpdateData.default_proposal = selectedProposalId;
      const result = await apiService.updateProfile(profileUpdateData);
      if (result?.status === 200) {
        localStorage.setItem('currentProjectId', String(projectId));
        localStorage.setItem('selectedProject', JSON.stringify(selectedProject));
        localStorage.setItem('currentProjectData', JSON.stringify(selectedProject));
        localStorage.setItem('project_category', selectedProject.project_category);
        if (selectedProposalId && selectedProposal) {
          localStorage.setItem('currentProposalId', String(selectedProposalId));
          const proposalData = { acquisition_proposal_id: selectedProposalId, acquisition_proposal_no: selectedProposal };
          localStorage.setItem('selectedProposal', JSON.stringify(proposalData));
          localStorage.setItem('currentProposalData', JSON.stringify(proposalData));
        } else {
          localStorage.removeItem('currentProposalId');
          localStorage.removeItem('selectedProposal');
          localStorage.removeItem('currentProposalData');
        }
        window.dispatchEvent(new Event("projectCategoryChanged"));
        setShowProjectSelection(false);
        localStorage.setItem('welcomeScreenShown', 'true'); // ✅ ADD THIS LINE

        window.location.href = window.location.href;
      } else { alert('Failed to update profile. Please try again.'); }
    } catch (error) { alert('An error occurred. Please try again.'); }
    finally { setUpdatingProject(false); }
  };

  const resetTableState = () => {
    setSearchQuery('');
    setSortConfig({ key: null, dir: null });
  };

  // ========== SECTION BOX CLICK ==========
  const handleSectionBoxClick = (sectionKey) => {
    resetTableState();
    if (selectedSection === sectionKey) {
      setSelectedSection(null);
      setSectionProposals([]);
      setSectionProposalsError('');
      if (mainView === 'tracking') {
        setMainView('proposals');
        setSelectedProposalForTracking(null);
        setTrackingStatus(null);
        setTrackingHistory([]);
      }
      setViewKey(k => k + 1);
      return;
    }
    setSelectedSection(sectionKey);
    setMainView('proposals');
    setSelectedProposalForTracking(null);
    setTrackingStatus(null);
    setTrackingHistory([]);
    setViewKey(k => k + 1);
    fetchSectionProposals(sectionKey);
  };

  // ========== ROW CLICK ==========
  const handleProposalRowClick = async (proposal) => {
    if (selectedProposalForTracking?.acquisition_proposal_id === proposal.acquisition_proposal_id && mainView === 'tracking') {
      setMainView('proposals');
      setSelectedProposalForTracking(null);
      setTrackingStatus(null);
      setTrackingHistory([]);
      setTrackingPage(1);
      setViewKey(k => k + 1);
      return;
    }
    setSelectedProposalForTracking(proposal);
    setTrackingPage(1);
    setTrackingLoading(true);
    setMainView('tracking');
    setViewKey(k => k + 1);
    try {
      const projectId = proposal.project_id || localStorage.getItem('currentProjectId');
      const proposalId = proposal.acquisition_proposal_id;
      const statusResponse = await apiService.getTrackingProposalForDashboard(projectId, proposalId);
      setTrackingStatus(statusResponse);
      await fetchTrackingPage(projectId, proposalId, 1);
    } catch (error) {
      console.error('Error fetching tracking data:', error);
    } finally {
      setTrackingLoading(false);
    }
  };

  const handleBackToProposals = () => {
    resetTableState();
    setMainView('proposals');
    setSelectedProposalForTracking(null);
    setTrackingStatus(null);
    setTrackingHistory([]);
    setTrackingPage(1);
    setTrackingTotalPages(1);
    setTrackingTotalRecords(0);
    setViewKey(k => k + 1);
  };

  const fetchTrackingPage = async (projectId, proposalId, page) => {
    setTrackingPaginationLoading(true);
    try {
      const historyResponse = await apiService.getTracking(projectId, proposalId, page, TRACKING_LIMIT);
      if (historyResponse?.data) {
        setTrackingHistory(Array.isArray(historyResponse.data) ? historyResponse.data : []);
        const totalPages = historyResponse.pagination?.totalPages || Math.ceil((historyResponse.pagination?.total || 0) / TRACKING_LIMIT);
        setTrackingTotalPages(totalPages);
        setTrackingTotalRecords(historyResponse.pagination?.total || 0);
      } else if (Array.isArray(historyResponse)) {
        setTrackingHistory(historyResponse);
        setTrackingTotalPages(1);
        setTrackingTotalRecords(historyResponse.length);
      }
    } catch (error) { console.error('Error fetching tracking page:', error); }
    finally { setTrackingPaginationLoading(false); }
  };

  const handleTrackingPageChange = async (newPage) => {
    if (!selectedProposalForTracking) return;
    const projectId = selectedProposalForTracking.project_id || localStorage.getItem('currentProjectId');
    const proposalId = selectedProposalForTracking.acquisition_proposal_id;
    setTrackingPage(newPage);
    await fetchTrackingPage(projectId, proposalId, newPage);
  };

  const handleDocumentClick = (documentUrl) => {
    setSelectedDocument(documentUrl);
    setShowDocumentModal(true);
  };

  // ========== SECTION CONFIG ==========
  const sectionConfig = [
    { key: 'section11', label: 'Section 11', gradient: 'from-blue-500 to-blue-700', bg: 'bg-blue-50', border: 'border-blue-500', text: 'text-blue-700', ring: 'ring-blue-400' },
    { key: 'section12', label: 'Section 12', gradient: 'from-blue-500 to-blue-700', bg: 'bg-blue-50', border: 'border-blue-500', text: 'text-blue-700', ring: 'ring-blue-400' },
    { key: 'section15', label: 'Section 15', gradient: 'from-blue-500 to-blue-700', bg: 'bg-blue-50', border: 'border-blue-500', text: 'text-blue-700', ring: 'ring-blue-400' },
    { key: 'section19', label: 'Section 19', gradient: 'from-blue-500 to-blue-700', bg: 'bg-blue-50', border: 'border-blue-500', text: 'text-blue-700', ring: 'ring-blue-400' },
    { key: 'section21', label: 'Section 21', gradient: 'from-blue-500 to-blue-700', bg: 'bg-blue-50', border: 'border-blue-500', text: 'text-blue-700', ring: 'ring-blue-400' },
    { key: 'section23', label: 'Section 23', gradient: 'from-blue-500 to-blue-700', bg: 'bg-blue-50', border: 'border-blue-500', text: 'text-blue-700', ring: 'ring-blue-400' },
    { key: 'payment', label: 'Payment', gradient: 'from-blue-500 to-blue-700', bg: 'bg-blue-50', border: 'border-blue-500', text: 'text-blue-700', ring: 'ring-blue-400' },
  ];

  const activeSec = selectedSection ? sectionConfig.find(s => s.key === selectedSection) : null;

  // ========== SHARED TABLE RENDERER ==========
  const renderProposalTable = (proposals, loading, error) => {
    if (loading) return (
      <div className="flex items-center justify-center py-14">
        <RefreshCw className="h-5 w-5 animate-spin text-blue-500 mr-2" />
        <span className="text-blue-500 text-sm font-medium">Loading proposals...</span>
      </div>
    );

    return (
      <>
        {error && proposals.length === 0 ? (
          <div className="text-center py-12">
            <AlertCircle className="h-10 w-10 mx-auto mb-2 text-amber-400" />
            <p className="text-sm text-amber-600">{error}</p>
          </div>
        ) : proposals.length === 0 ? (
          <div className="text-center py-12">
            <FileText className="h-10 w-10 mx-auto mb-2 text-gray-200" />
            <p className="text-gray-400 text-sm">{searchQuery ? 'No proposals match your search' : 'No proposals found'}</p>
          </div>
        ) : (
          <div className="rounded-xl overflow-hidden border border-blue-100 shadow-[0_2px_16px_rgba(59,130,246,0.09)]">
            <div className="overflow-x-auto max-h-[420px] overflow-y-auto">
              <table className="w-full">
                <thead className="bg-gradient-to-r from-blue-600 to-blue-800 sticky top-0 z-10">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-white tracking-wider w-14">#</th>

                    {/* Proposal No — sortable */}
                    <th
                      className="px-4 py-3 text-left text-sm font-semibold text-white tracking-wider cursor-pointer select-none group hover:bg-white/10 transition-colors"
                      onClick={() => handleSort('acquisition_proposal_no')}
                    >
                      <span className="flex items-center gap-1">
                        Proposal No
                        <SortIcon colKey="acquisition_proposal_no" />
                      </span>
                    </th>

                    {/* Bhusampadan No — sortable */}
                    <th
                      className="px-4 py-3 text-left text-sm font-semibold text-white tracking-wider cursor-pointer select-none group hover:bg-white/10 transition-colors"
                      onClick={() => handleSort('section_11_bhusampadan_no')}
                    >
                      <span className="flex items-center gap-1">
                        Bhusampadan No
                        <SortIcon colKey="section_11_bhusampadan_no" />
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {proposals.map((proposal, index) => {
                    const isActive = selectedProposalForTracking?.acquisition_proposal_id === proposal.acquisition_proposal_id;
                    return (
                      <tr
                        key={index}
                        onClick={() => handleProposalRowClick(proposal)}
                        className={`border-t border-blue-50 cursor-pointer transition-all duration-150 text-sm ${isActive ? 'bg-blue-100' : 'hover:bg-blue-50'}`}
                      >
                        <td className="px-4 py-3 text-blue-300 text-sm font-medium">{index + 1}</td>
                        <td className="px-4 py-3 font-semibold text-blue-700">{proposal.acquisition_proposal_no || '-'}</td>
                        <td className="px-4 py-3 text-blue-500">{proposal.section_11_bhusampadan_no || '-'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </>
    );
  };

  // ========== TRACKING VIEW ==========
  const renderTrackingView = () => {
    if (!selectedProposalForTracking) return null;

    const formatDateTime = (dateString) => {
      if (!dateString) return 'N/A';
      return new Date(dateString).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    };

    const trackSections = [
      { key: 'section11', label: 'Section 11' }, { key: 'section12', label: 'Section 12' },
      { key: 'section15', label: 'Section 15' }, { key: 'section19', label: 'Section 19' },
      { key: 'section21', label: 'Section 21' }, { key: 'section23', label: 'Section 23' },
      { key: 'compensation', label: 'Compensation' }, { key: 'payment', label: 'Payment' }
    ];

    const getLastCompletedIndex = () => {
      if (!trackingStatus?.sections) return -1;
      let last = -1;
      trackSections.forEach((s, i) => { if (trackingStatus.sections[s.key] === true) last = i; });
      return last;
    };
    const lastDone = getLastCompletedIndex();

    return (
      <div>
        {trackingLoading ? (
          <div className="flex items-center justify-center py-14">
            <div className="animate-spin rounded-full h-10 w-10 border-2 border-blue-600 border-t-transparent"></div>
            <span className="ml-3 text-gray-500 text-sm">Loading tracking data...</span>
          </div>
        ) : (
          <>
            {/* Progress stepper */}
            <div className="bg-gray-50 rounded-xl p-4 mb-4 border border-gray-100">
              <p className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-3">Progress Status</p>
              <div className="flex items-start justify-between relative">
                <div className="absolute top-4 left-4 right-4 h-0.5 bg-gray-200 z-0">
                  <div className="h-full bg-gradient-to-r from-green-400 to-green-600 transition-all duration-700 ease-out"
                    style={{ width: lastDone >= 0 ? `${((lastDone) / (trackSections.length - 1)) * 100}%` : '0%' }} />
                </div>
                {trackSections.map((section, index) => {
                  const done = index <= lastDone;
                  return (
                    <div key={section.key} className="flex flex-col items-center z-10 relative flex-1 min-w-0">
                      <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 border-2 text-sm flex-shrink-0 ${done ? 'bg-green-500 border-green-500 text-white shadow-md' : 'bg-white border-gray-200 text-gray-300'}`}>
                        {done ? <CheckCircle className="h-4 w-4" /> : <Clock className="h-4 w-4" />}
                      </div>
                      <span className={`text-sm mt-1.5 font-medium text-center leading-tight ${done ? 'text-green-600' : 'text-gray-400'}`}>{section.label}</span>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* History table */}
            <p className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-2">Tracking History</p>
            {trackingPaginationLoading ? (
              <div className="flex items-center justify-center py-8">
                <div className="animate-spin rounded-full h-6 w-6 border-2 border-blue-600 border-t-transparent"></div>
                <span className="ml-2 text-gray-500 text-sm">Loading...</span>
              </div>
            ) : trackingHistory?.length > 0 ? (
              <>
                <div className="rounded-xl border border-blue-100 overflow-hidden shadow-[0_2px_16px_rgba(59,130,246,0.08)]">
                  <div className="overflow-x-auto max-h-[280px] overflow-y-auto">
                    <table className="w-full text-sm">
                      <thead className="bg-gradient-to-r from-blue-600 to-blue-800 sticky top-0">
                        <tr>
                          <th className="px-3 py-2.5 text-left font-semibold text-white tracking-wider">From Stage</th>
                          <th className="px-2 py-2.5 w-6"></th>
                          <th className="px-3 py-2.5 text-left font-semibold text-white tracking-wider">To Stage</th>
                          <th className="px-3 py-2.5 text-left font-semibold text-white tracking-wider">Date</th>
                          <th className="px-3 py-2.5 text-left font-semibold text-white tracking-wider">Doc</th>
                        </tr>
                      </thead>
                      <tbody>
                        {trackingHistory.map((item, index) => (
                          <tr key={index} className="border-t border-blue-50 hover:bg-blue-50 transition">
                            <td className="px-3 py-2.5 text-blue-600 font-medium">{item.from_stage_name}</td>
                            <td className="px-2 py-2.5 text-black-300"><ArrowRight className="h-3 w-3" /></td>
                            <td className="px-3 py-2.5 text-green-600 font-semibold">{item.to_stage_name}</td>
                            <td className="px-3 py-2.5 text-gray-400">{formatDateTime(item.cre_usr_dt)}</td>
                            <td className="px-3 py-2.5">
                              {item.upload_path
                                ? <button onClick={() => handleDocumentClick(item.upload_path)} className="flex items-center gap-1 px-2 py-1 bg-blue-50 text-blue-600 rounded hover:bg-blue-100 font-medium"><Eye className="h-3 w-3" /> View</button>
                                : <span className="text-gray-200">—</span>
                              }
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {trackingTotalPages > 1 && (
                  <div className="flex items-center justify-between mt-3 px-1">
                    <p className="text-sm text-gray-400">Page {trackingPage} of {trackingTotalPages}{trackingTotalRecords > 0 && ` · ${trackingTotalRecords} records`}</p>
                    <div className="flex items-center gap-1">
                      <button onClick={() => handleTrackingPageChange(trackingPage - 1)} disabled={trackingPage === 1 || trackingPaginationLoading} className="p-1.5 rounded border border-gray-200 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"><ChevronLeft className="h-3.5 w-3.5 text-gray-500" /></button>
                      {Array.from({ length: trackingTotalPages }, (_, i) => i + 1)
                        .filter(p => p === 1 || p === trackingTotalPages || Math.abs(p - trackingPage) <= 1)
                        .reduce((acc, p, idx, arr) => { if (idx > 0 && p - arr[idx - 1] > 1) acc.push('...'); acc.push(p); return acc; }, [])
                        .map((item, idx) => item === '...'
                          ? <span key={`e-${idx}`} className="px-1 text-gray-300 text-sm">…</span>
                          : <button key={item} onClick={() => handleTrackingPageChange(item)} disabled={trackingPaginationLoading} className={`w-7 h-7 rounded text-sm font-medium border ${trackingPage === item ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50'} disabled:opacity-40`}>{item}</button>
                        )}
                      <button onClick={() => handleTrackingPageChange(trackingPage + 1)} disabled={trackingPage === trackingTotalPages || trackingPaginationLoading} className="p-1.5 rounded border border-gray-200 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"><ChevronRight className="h-3.5 w-3.5 text-gray-500" /></button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center py-10 bg-gray-50 rounded-xl border border-gray-100">
                <Clock className="h-10 w-10 mx-auto mb-2 text-gray-200" />
                <p className="text-sm text-gray-400">No tracking history available</p>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  // ========== DOCUMENT MODAL ==========
  const renderDocumentModal = () => {
    if (!showDocumentModal || !selectedDocument) return null;
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[70] flex items-center justify-center p-4 anim-fade">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl h-[90vh] flex flex-col">
          <div className="flex items-center justify-between p-4 border-b border-gray-200">
            <h3 className="text-base font-semibold text-gray-800 flex items-center gap-2"><FileText className="h-5 w-5 text-blue-600" />Document Viewer</h3>
            <button onClick={() => { setShowDocumentModal(false); setSelectedDocument(null); }} className="p-2 hover:bg-gray-100 rounded-lg"><X className="h-5 w-5 text-gray-600" /></button>
          </div>
          <div className="flex-1 overflow-hidden">
            <iframe src={selectedDocument} className="w-full h-full border-0" title="Document Viewer" />
          </div>
        </div>
      </div>
    );
  };

  // ========== WELCOME ==========
  const renderWelcomeScreen = () => (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-50 anim-fade">
      <div className="text-center anim-scale">
        <h1 className="text-4xl font-bold text-transparent bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 bg-clip-text mb-2">Welcome</h1>
        <p className="text-gray-600 text-lg">{userData.user_role_name || ''}</p>
        <div className="mt-6"><div className="h-1 w-32 mx-auto bg-gradient-to-r from-amber-400 to-amber-600 rounded-full animate-pulse"></div></div>
      </div>
    </div>
  );

  // ========== PROJECT SELECTION MODAL ==========
  // const renderProjectSelectionScreen = () => (
  //     <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-[60] anim-fade backdrop-blur-sm">
  //         <div className="anim-scale max-w-lg w-full mx-4">
  //             <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
  //                 <div className="mb-6 text-center">
  //                     <div className="p-3 bg-gradient-to-br from-blue-600 to-blue-900 rounded-full w-14 h-14 mx-auto mb-4 flex items-center justify-center shadow-lg"><Briefcase className="h-7 w-7 text-white" /></div>
  //                     <h2 className="text-xl font-bold text-transparent bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text mb-1">
  //                         {showDashboard ? 'Change Project' : 'Select Project'}
  //                     </h2>
  //                     <p className="text-gray-500 text-sm">{showDashboard ? 'Choose a different project' : 'Choose a project to continue'}</p>
  //                 </div>
  //                 <div className="space-y-4">
  //                     {[
  //                         { label: 'Category', value: filterCategory, onChange: (v) => { setFilterCategory(v); setFiltersApplied(true); fetchModalProjects(v, filterDivision, filterLegacy); }, options: [['', 'Select Category'], ['General', 'Other'], ['Railway', 'Railway'], ['Highway', 'Highway']] },
  //                         { label: 'Project Type', value: filterDivision, onChange: (v) => { setFilterDivision(v); setFiltersApplied(true); fetchModalProjects(filterCategory, v, filterLegacy); }, options: [['', 'All'], ['Road Infrastructure', 'Road Infrastructure'], ['Irrigation Infrastructure', 'Irrigation Infrastructure'], ['Urban Development', 'Urban Development'], ['Industrial Development', 'Industrial Development'], ['Educational Infrastructure', 'Educational Infrastructure'], ['Healthcare Infrastructure', 'Healthcare Infrastructure'], ['Agricultural', 'Agricultural'], ['Transportation', 'Transportation'], ['Building Construction', 'Building Construction']] },
  //                         { label: 'Legacy', value: filterLegacy, onChange: (v) => { setFilterLegacy(v); setFiltersApplied(true); fetchModalProjects(filterCategory, filterDivision, v); }, options: [['0', 'No'], ['1', 'Yes'], ['', 'All']] },
  //                     ].map(({ label, value, onChange, options }) => (
  //                         <div key={label}>
  //                             <label className="block text-left text-sm font-semibold text-gray-700 mb-1.5">📋 {label}</label>
  //                             <select value={value} onChange={e => onChange(e.target.value)} className="w-full p-3 border-2 border-gray-200 rounded-lg focus:border-blue-300 bg-gray-50 text-sm">
  //                                 {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
  //                             </select>
  //                         </div>
  //                     ))}
  //                     <div>
  //                         <label className="block text-left text-sm font-semibold text-gray-700 mb-1.5">🏗️ Select Project <span className="text-red-500">*</span></label>
  //                         <div className="relative">
  //                             <div className="w-full p-3 bg-gray-50 border-2 border-gray-200 rounded-lg cursor-pointer flex items-center justify-between hover:border-blue-300 transition-colors min-h-[50px]"
  //                                 onClick={() => { if (projects.length > 0 && !projectsLoading) setDropdownOpen(!dropdownOpen); else if (!projectsLoading) alert('Please apply filters or wait for projects to load'); }}>
  //                                 {projectsLoading ? <div className="text-gray-500 flex items-center text-sm"><RefreshCw className="h-4 w-4 animate-spin mr-2" />Loading...</div>
  //                                     : selectedProject ? <span className="text-sm font-medium text-gray-900">{selectedProject.project_name}</span>
  //                                         : <span className="text-gray-400 text-sm">Select Project</span>}
  //                                 <ChevronDown className={`h-4 w-4 text-gray-400 transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} />
  //                             </div>
  //                             {dropdownOpen && !projectsLoading && (
  //                                 <div className="absolute top-full left-0 right-0 mt-1 bg-white border-2 border-gray-200 rounded-lg shadow-xl z-20 max-h-60 overflow-y-auto">
  //                                     {projectError ? <div className="p-4 text-center text-red-500 text-sm">{projectError}</div>
  //                                         : projects.length > 0 ? projects.map(project => (
  //                                             <div key={project.id || project.project_id} className="p-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0 text-sm" onClick={() => handleProjectSelectOnly(project)}>
  //                                                 <span className="font-medium">{project.project_name}</span>
  //                                                 <span className="text-gray-400 text-sm ml-1">({project.project_category})</span>
  //                                             </div>
  //                                         )) : <div className="p-4 text-center text-gray-400 text-sm">No Projects Available</div>}
  //                                 </div>
  //                             )}
  //                         </div>
  //                     </div>
  //                     {selectedProject && (
  //                         <div>
  //                             <label className="block text-left text-sm font-semibold text-gray-700 mb-1.5">📋 Select Proposal (Optional)</label>
  //                             {proposalsLoading ? <div className="p-3 border-2 border-gray-200 rounded-lg flex items-center justify-center text-sm text-gray-500"><RefreshCw className="h-4 w-4 animate-spin mr-2" />Loading...</div>
  //                                 : proposalList.length > 0 ? (
  //                                     <select value={selectedProposal} onChange={e => { const v = e.target.value; if (!v) { setSelectedProposal(''); setSelectedProposalId(null); } else { const f = proposalList.find(p => p.acquisition_proposal_no === v); if (f) { setSelectedProposal(f.acquisition_proposal_no); setSelectedProposalId(f.acquisition_proposal_id); } } }} className="w-full p-3 border-2 border-gray-200 rounded-lg focus:border-blue-300 bg-gray-50 text-sm">
  //                                         <option value="">No Proposal Selected (Optional)</option>
  //                                         {proposalList.map((p, i) => <option key={i} value={p.acquisition_proposal_no}>{p.acquisition_proposal_no}</option>)}
  //                                     </select>
  //                                 ) : <div className="p-3 text-center text-gray-400 text-sm border-2 border-gray-200 rounded-lg">No Proposals Found</div>}
  //                         </div>
  //                     )}
  //                     <div className={`pt-3 ${(showDashboard || filtersApplied) ? 'grid grid-cols-2 gap-3' : 'flex flex-col gap-3'}`}>
  //                         <button onClick={handleProceedToDashboard} disabled={!canProceed || updatingProject} className={`px-6 py-3 rounded-lg font-semibold text-sm transition-all duration-300 ${canProceed && !updatingProject ? 'bg-gradient-to-r from-blue-600 to-blue-900 text-white hover:from-blue-700 hover:to-blue-800 shadow-md' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`}>
  //                             {updatingProject ? <span className="flex items-center justify-center gap-2"><div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>Updating...</span> : 'Continue'}
  //                         </button>
  //                         {(showDashboard || filtersApplied) && (
  //                             <button onClick={() => { setShowProjectSelection(false); setDropdownOpen(false); setSelectedProject(null); setSelectedProposal(''); setSelectedProposalId(null); setProposalList([]); setFiltersApplied(false); setFilterCategory(''); setFilterDivision(''); setFilterLegacy('0'); }} className="px-6 py-3 border-2 border-gray-300 text-gray-600 rounded-lg hover:border-blue-300 hover:text-blue-600 font-semibold text-sm">Cancel</button>
  //                         )}
  //                     </div>
  //                 </div>
  //             </div>
  //         </div>
  //     </div>
  // );
  const renderProjectSelectionScreen = () => (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-[60] anim-fade backdrop-blur-sm">
      <div className="anim-scale max-w-lg w-full mx-4">
        <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
          <div className="mb-6 text-center">
            <div className="p-3 bg-gradient-to-br from-blue-600 to-blue-900 rounded-full w-14 h-14 mx-auto mb-4 flex items-center justify-center shadow-lg">
              <Briefcase className="h-7 w-7 text-white" />
            </div>
            <h2 className="text-xl font-bold text-transparent bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text mb-1">
              {showDashboard ? 'Change Project' : 'Select Project'}
            </h2>
            <p className="text-gray-500 text-sm">
              {showDashboard ? 'Choose a different project' : 'Choose a project to continue'}
            </p>
          </div>

          <div className="space-y-4">
            {/* Category (Kept) */}
            <div>
              <label className="block text-left text-sm font-semibold text-gray-700 mb-1.5">
                📋 Category
              </label>
              <select
                value={filterCategory}
                onChange={e => {
                  const v = e.target.value;
                  setFilterCategory(v);
                  setFiltersApplied(true);
                  fetchModalProjects(v); // now only category filter
                }}
                className="w-full p-3 border-2 border-gray-200 rounded-lg focus:border-blue-300 bg-gray-50 text-sm"
              >
                <option value="">Select Category</option>
                {categories.map(cat => (
                  <option key={cat.category_id} value={cat.eng_category_name}>
                    {/* {language === 'en' ? cat.eng_category_name : cat.category_name} */}
                    {cat.category_name}
                  </option>
                ))}
              </select>
            </div>

            {/* Select Project */}
            <div>
              <label className="block text-left text-sm font-semibold text-gray-700 mb-1.5">
                🏗️ Select Project <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <div
                  className="w-full p-3 bg-gray-50 border-2 border-gray-200 rounded-lg cursor-pointer flex items-center justify-between hover:border-blue-300 transition-colors min-h-[50px]"
                  onClick={() => {
                    if (projects.length > 0 && !projectsLoading) {
                      setDropdownOpen(!dropdownOpen);
                    } else if (!projectsLoading) {
                      alert('Please select category or wait for projects to load');
                    }
                  }}
                >
                  {projectsLoading ? (
                    <div className="text-gray-500 flex items-center text-sm">
                      <RefreshCw className="h-4 w-4 animate-spin mr-2" />
                      Loading...
                    </div>
                  ) : selectedProject ? (
                    <span className="text-sm font-medium text-gray-900">
                      {selectedProject.project_name}
                    </span>
                  ) : (
                    <span className="text-gray-400 text-sm">Select Project</span>
                  )}
                  <ChevronDown
                    className={`h-4 w-4 text-gray-400 transition-transform ${dropdownOpen ? 'rotate-180' : ''
                      }`}
                  />
                </div>

                {dropdownOpen && !projectsLoading && (
                  <div className="absolute top-full left-0 right-0 mt-1 bg-white border-2 border-gray-200 rounded-lg shadow-xl z-20 max-h-60 overflow-y-auto">
                    {projectError ? (
                      <div className="p-4 text-center text-red-500 text-sm">
                        {projectError}
                      </div>
                    ) : projects.length > 0 ? (
                      projects.map(project => (
                        <div
                          key={project.id || project.project_id}
                          className="p-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0 text-sm"
                          onClick={() => handleProjectSelectOnly(project)}
                        >
                          <span className="font-medium">
                            {project.project_name}
                          </span>
                          <span className="text-gray-400 text-sm ml-1">
                            ({project.project_category})
                          </span>
                        </div>
                      ))
                    ) : (
                      <div className="p-4 text-center text-gray-400 text-sm">
                        No Projects Available
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Select Proposal */}
            {selectedProject && (
              <div>
                <label className="block text-left text-sm font-semibold text-gray-700 mb-1.5">
                  📋 Select Proposal (Optional)
                </label>
                {proposalsLoading ? (
                  <div className="p-3 border-2 border-gray-200 rounded-lg flex items-center justify-center text-sm text-gray-500">
                    <RefreshCw className="h-4 w-4 animate-spin mr-2" />
                    Loading...
                  </div>
                ) : proposalList.length > 0 ? (
                  <select
                    value={selectedProposal}
                    onChange={e => {
                      const v = e.target.value;
                      if (!v) {
                        setSelectedProposal('');
                        setSelectedProposalId(null);
                      } else {
                        const f = proposalList.find(
                          p => p.acquisition_proposal_no === v
                        );
                        if (f) {
                          setSelectedProposal(f.acquisition_proposal_no);
                          setSelectedProposalId(f.acquisition_proposal_id);
                        }
                      }
                    }}
                    className="w-full p-3 border-2 border-gray-200 rounded-lg focus:border-blue-300 bg-gray-50 text-sm"
                  >
                    <option value="">No Proposal Selected (Optional)</option>
                    {proposalList.map((p, i) => (
                      <option key={i} value={p.acquisition_proposal_no}>
                        {p.acquisition_proposal_no}
                      </option>
                    ))}
                  </select>
                ) : (
                  <div className="p-3 text-center text-gray-400 text-sm border-2 border-gray-200 rounded-lg">
                    No Proposals Found
                  </div>
                )}
              </div>
            )}

            <div className={`pt-3 ${showDashboard ? 'grid grid-cols-2 gap-3' : 'flex flex-col gap-3'}`}>
              <button
                onClick={handleProceedToDashboard}
                disabled={!canProceed || updatingProject}
                className={`px-6 py-3 rounded-lg font-semibold text-sm transition-all duration-300 ${canProceed && !updatingProject
                  ? 'bg-gradient-to-r from-blue-600 to-blue-900 text-white hover:from-blue-700 hover:to-blue-800 shadow-md'
                  : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                  }`}
              >
                {updatingProject ? 'Updating...' : 'Continue'}
              </button>

              {showDashboard && (
                <button
                  onClick={() => {
                    setShowProjectSelection(false);
                    setDropdownOpen(false);
                    setSelectedProject(null);
                    setSelectedProposal('');
                    setSelectedProposalId(null);
                    setProposalList([]);
                    setFilterCategory('');
                    setFiltersApplied(false);
                  }}
                  className="px-6 py-3 border-2 border-gray-300 text-gray-600 rounded-lg hover:border-blue-300 hover:text-blue-600 font-semibold text-sm"
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  // ========== MAIN DASHBOARD ==========
  return (
    <>
      <style jsx>{`
                @keyframes aFade   { from { opacity:0 }                       to { opacity:1 } }
                @keyframes aScale  { from { opacity:0; transform:scale(0.95) } to { opacity:1; transform:scale(1) } }
                .anim-fade  { animation: aFade  0.4s ease-out both; }
                .anim-scale { animation: aScale 0.4s ease-out both; }
                .ci {
                    opacity: 0;
                    transform: translateY(20px);
                    transition: opacity 0.35s ease-out, transform 0.35s ease-out;
                    transition-delay: var(--d, 0s);
                }
                .ready .ci { opacity: 1; transform: translateY(0); }
                .swap-in { animation: swapIn 0.28s cubic-bezier(0.16,1,0.3,1) both; }
                @keyframes swapIn {
                    from { opacity:0; transform:translateY(12px) scale(0.99); }
                    to   { opacity:1; transform:translateY(0)    scale(1);    }
                }
            `}</style>

      {showWelcome && renderWelcomeScreen()}
      {showProjectSelection && renderProjectSelectionScreen()}

      <div className={`bg-white min-h-screen p-6 ${mounted ? 'ready' : ''}`}>

        {/* TOP BAR */}
        <div
          className={`ci flex flex-col md:flex-row items-center mb-5 gap-3 ${hideDashboard ? "md:justify-end" : "md:justify-between"
            }`}
          style={{ '--d': '0.05s' }}
        >
          {!hideDashboard && (
            <div className="bg-yellow-300 px-4 py-2 rounded-lg text-sm font-medium text-gray-700 shadow-sm">
              Dashboard of Live Total Proposals: <span className="font-bold text-blue-600 ml-1">{dashboardProposalList.length || 0}</span>
            </div>
          )}
          <div className="flex gap-2.5">
            <button
              onClick={() => { setShowProjectSelection(true); setShowDashboard(true); fetchModalProjects('', '', filterLegacy); fetchCategories(); }}
              className="px-4 py-2 text-sm bg-white text-gray-700 border border-gray-200 rounded-xl flex items-center gap-2 hover:bg-gray-50 transition-all shadow-sm"
            >
              <Briefcase className="h-4 w-4" />
              {translations[language]?.ChangeProject || 'Change Project'}
            </button>
            {/* <button
                            onClick={() => setSelectedComponent?.('AllDocument')}
                            className="px-5 py-2 text-sm bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-xl flex items-center gap-2 hover:from-blue-700 hover:to-blue-900 transition-all shadow-md"
                        >
                            <FileText className="h-4 w-4" />
                            {translations[language]?.AllDocument || 'All Document'}
                        </button> */}
          </div>
        </div>

        {!hideDashboard && (
          isLoading ? (
            <div className="ci" style={{ '--d': '0.1s' }}>
              <div className="flex justify-center items-center h-80">
                <div className="text-center">
                  <div className="inline-flex relative">
                    <div className="w-16 h-16 rounded-full border-4 border-slate-200 border-t-blue-600 animate-spin"></div>
                    <div className="absolute inset-0 flex items-center justify-center"><FileText className="h-6 w-6 text-blue-400 animate-pulse" /></div>
                  </div>
                  <p className="text-gray-400 mt-4 text-sm">Loading dashboard...</p>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden">

              {/* SECTION COUNT BOXES */}
              <div className="ci p-5 pb-4 border-b border-gray-100" style={{ '--d': '0.13s' }}>
                <div className="grid grid-cols-7 gap-3">
                  {sectionConfig.map((sec, i) => {
                    const count = sectionCounts[sec.key] ?? 0;
                    const isSelected = selectedSection === sec.key;
                    return (
                      <div
                        key={sec.key}
                        onClick={() => handleSectionBoxClick(sec.key)}
                        className={`
                                                ci relative cursor-pointer rounded-xl border-2 overflow-hidden flex
                                                transition-all duration-250 ease-out select-none
                                                ${isSelected
                            ? `${sec.border} shadow-xl scale-105 ring-2 ${sec.ring} ring-offset-1`
                            : 'border-gray-100 hover:border-blue-400 hover:shadow-[0_4px_16px_rgba(59,130,246,0.18)] hover:-translate-y-0.5 active:scale-95'}
                                            `}
                        style={{ '--d': `${0.18 + i * 0.055}s` }}
                      >
                        <div className={`w-1.5 flex-shrink-0 bg-gradient-to-b ${sec.gradient}`} />
                        <div className={`p-3 flex-1 ${isSelected ? sec.bg : 'bg-white'}`}>
                          <p className={`text-base font-semibold mb-0.5 ${isSelected ? sec.text : 'text-gray-400'}`}>{sec.label}</p>
                          <p className={`text-2xl font-bold tracking-tight ${isSelected ? sec.text : 'text-gray-800'}`}>{count}</p>
                        </div>
                        {isSelected && <div className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full" />}
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* BOTTOM PANEL */}
              <div className="ci p-5" style={{ '--d': '0.22s' }}>
                {/* Sub-header */}
                <div className="flex items-center justify-between mb-3 px-3 py-2 bg-blue-50 border border-blue-100 rounded-xl shadow-sm gap-3">

                  {/* Left - Title */}
                  <span className={`flex items-center gap-2 text-sm font-bold whitespace-nowrap ${mainView === 'tracking' ? 'text-blue-700' : activeSec ? activeSec.text : 'text-blue-700'}`}>
                    {mainView === 'tracking' ? (
                      <>
                        <Activity className="h-4 w-4" />
                        Progress Status of {selectedProposalForTracking?.acquisition_proposal_no}
                      </>
                    ) : (
                      <>
                        <List className="h-4 w-4" />
                        {activeSec ? `${activeSec.label} — Proposals` : 'All Proposals'}
                        {!activeSec && dashboardProposalList.length > 0 && (
                          <span className="bg-blue-600 text-white text-sm px-2 py-0.5 rounded-full ml-1">
                            {dashboardProposalList.length}
                          </span>
                        )}
                      </>
                    )}
                  </span>

                  {/* Center - Search bar (inline) */}
                  {mainView === 'proposals' && (
                    <div className="relative flex-1 max-w-sm">
                      <input
                        type="text"
                        value={searchQuery}
                        onChange={e => setSearchQuery(e.target.value)}
                        placeholder="Search by Proposal No or Bhusampadan No..."
                        className="w-full pl-8 pr-8 py-1.5 text-sm border border-blue-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-400 placeholder-gray-400 transition-all"
                      />
                      <svg className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z" />
                      </svg>
                      {searchQuery && (
                        <button onClick={() => setSearchQuery('')} className="absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors">
                          <X className="h-3 w-3" />
                        </button>
                      )}
                    </div>
                  )}

                  {/* Right - Action buttons */}
                  <div className="flex items-center gap-2">
                    {mainView === 'tracking' && (
                      <button onClick={handleBackToProposals} className="flex items-center gap-1.5 px-3 py-1.5 bg-white hover:bg-blue-100 text-blue-700 rounded-lg text-sm font-semibold border border-blue-200 transition-colors">
                        <ArrowLeft className="h-3.5 w-3.5" />
                        Back to Proposals
                      </button>
                    )}
                    {activeSec && mainView === 'proposals' && (
                      <button onClick={() => { setSelectedSection(null); setSectionProposals([]); resetTableState(); setViewKey(k => k + 1); }} className="flex items-center gap-1 text-sm text-gray-500 hover:text-red-500 transition-colors px-2 py-1 rounded hover:bg-red-50">
                        <X className="h-3 w-3" />
                        Clear
                      </button>
                    )}
                  </div>

                </div>

                {/* Swappable content */}
                <div className="swap-in" key={`${mainView}-${selectedSection || 'all'}-${viewKey}`}>
                  {mainView === 'tracking'
                    ? renderTrackingView()
                    : selectedSection
                      ? renderProposalTable(filteredSectionProposals, sectionProposalsLoading, sectionProposalsError)
                      : renderProposalTable(filteredDashboardProposals, dashboardProposalsLoading, dashboardProposalError)
                  }
                </div>
              </div>
            </div>
          )

        )}
      </div>

      {renderDocumentModal()}
    </>
  );
};

export default DashboardHighway;